import styled from 'styled-components'
import { CircleProps } from './interface'

export const CircleLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSize.xxxs};
`

export const CircleTag = styled.div<CircleProps>`
  border: ${({ small }) => (small ? '2px' : '1px')} solid;
  border-color: ${({ theme, borderColor = 'blueGray50' }) => theme.palette[borderColor]};
  background-color: ${({ theme, color }) => theme.palette[color]};
  width: ${({ theme, small }) => (small ? theme.layout.xxs : theme.layout.xs)};
  height: ${({ theme, small }) => (small ? theme.layout.xxs : theme.layout.xs)};
  border-radius: ${({ theme }) => theme.layout.xxxl};
`

export const InlineText = styled.div`
  display: flex;
  align-items: center;
  width: max-content;

  ${CircleTag} {
    margin-right: ${({ theme }) => theme.space.xs};
  }
`
